import { render, staticRenderFns } from "./ExpiredDemoMode.vue?vue&type=template&id=31084e13"
import script from "./ExpiredDemoMode.vue?vue&type=script&lang=js"
export * from "./ExpiredDemoMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports